module.exports = __webpack_public_path__ + "app/modals/message-overwrite-warning-modal.view.html";